import Base from './base';

export default class Inventory extends Base {
  resource = '/inventories';
}
